import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TitleInsuranceContact } from '@models/businesses';
import { TitleInsuranceProvider } from '@models/title-insurance';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { BusinessDispatch, BusinessState } from '@state/business';
import { ICON } from '@core/util/icon';

export interface TitleInsuranceContactInfoModalData {
	provider: TitleInsuranceProvider;
}

@Component({
	selector: 'app-title-insurance-contact-modal',
	templateUrl: './contact-info-modal.component.html',
	standalone: false,
})
export class TitleInsuranceContactInfoModalComponent implements OnInit {
	public ICON = ICON;
	public name: string;
	public phone: string;
	public title: string;
	public email: string;
	public provider: TitleInsuranceProvider;
	public addContact = false;
	public companyName: string;
	public companyPhone: string[];
	public companyFax: string[];
	public companyAddress: string;
	public contact: TitleInsuranceContact;

	@ViewSelectSnapshot(BusinessState.chicagoContact)
	chicagoContact: TitleInsuranceContact;
	@ViewSelectSnapshot(BusinessState.fctContact)
	fctContact: TitleInsuranceContact;
	@ViewSelectSnapshot(BusinessState.stewartContact)
	stewartContact: TitleInsuranceContact;
	@ViewSelectSnapshot(BusinessState.titlePlusContact)
	titlePlusContact: TitleInsuranceContact;

	constructor(
		private dialogRef: MatDialogRef<TitleInsuranceContactInfoModalComponent>,
		private businessDispatch: BusinessDispatch,
		@Inject(MAT_DIALOG_DATA) public data: TitleInsuranceContactInfoModalData,
	) {}

	ngOnInit(): void {
		this.provider = this.data.provider;
		this.setCompanyDetails();
	}

	toggleAddContact(): void {
		this.addContact = !this.addContact;
	}

	addContactDetails(): void {
		switch (this.provider) {
			case TitleInsuranceProvider.CHICAGO:
				this.businessDispatch.SetChicagoContact({
					name: this.name,
					phone: this.phone,
					title: this.title,
					email: this.email,
				});
				break;
			case TitleInsuranceProvider.STEWART:
				this.businessDispatch.SetStewartContact({
					name: this.name,
					phone: this.phone,
					title: this.title,
					email: this.email,
				});
				break;
			case TitleInsuranceProvider.FCT:
				this.businessDispatch.SetFCTContact({
					name: this.name,
					phone: this.phone,
					title: this.title,
					email: this.email,
				});
				break;
			case TitleInsuranceProvider.TITLE_PLUS:
				this.businessDispatch.SetTitlePlusContact({
					name: this.name,
					phone: this.phone,
					title: this.title,
					email: this.email,
				});
				break;
			default:
				this.dialogRef.close(false);
				break;
		}

		this.dialogRef.close(true);
	}

	deleteContactInfo(): void {
		switch (this.provider) {
			case TitleInsuranceProvider.CHICAGO:
				this.businessDispatch.SetChicagoContact(null);
				break;
			case TitleInsuranceProvider.STEWART:
				this.businessDispatch.SetStewartContact(null);
				break;
			case TitleInsuranceProvider.FCT:
				this.businessDispatch.SetFCTContact(null);
				break;
			case TitleInsuranceProvider.TITLE_PLUS:
				this.businessDispatch.SetTitlePlusContact(null);
				break;
			default:
				break;
		}
		this.contact = null;
		this.name = '';
		this.phone = '';
		this.title = '';
		this.email = '';
		this.toggleAddContact();
	}

	close(): void {
		this.dialogRef.close();
	}

	setContactDetails(contact: TitleInsuranceContact): void {
		this.contact = contact;
		this.name = contact?.name || '';
		this.phone = contact?.phone || '';
		this.title = contact?.title || '';
		this.email = contact?.email || '';
	}

	setCompanyDetails(): void {
		switch (this.provider) {
			case TitleInsuranceProvider.CHICAGO:
				this.companyName = 'Chicago Title Insurance Company';
				this.companyPhone = ['(888) 868-4853'];
				this.companyFax = ['(888) 214-1953'];
				this.companyAddress = '55 Superior Boulevard, Mississauga, ON L5T 2X9';
				this.setContactDetails(this.chicagoContact);
				break;
			case TitleInsuranceProvider.STEWART:
				this.companyName = 'Stewart Title Insurance Company';
				this.companyPhone = ['(866) 969-9101'];
				this.companyFax = ['(888) 667-5151'];
				this.companyAddress =
					'Royal Bank Plaza, North Tower 200 Bay Street, Suite 2600, Toronto, ON M5J 2J2';
				this.setContactDetails(this.stewartContact);
				break;
			case TitleInsuranceProvider.FCT:
				this.companyName = 'First Canadian Title';
				this.companyPhone = ['(866) 804-3122', '(905) 287-3122'];
				this.companyFax = ['(800) 705-0006', '(905) 287-2403'];
				this.companyAddress =
					'2235 Sheridan Garden Drive, Oakville, ON L6J 7Y5';
				this.setContactDetails(this.fctContact);
				break;
			case TitleInsuranceProvider.TITLE_PLUS:
				this.companyName = 'TitlePLUS';
				this.companyPhone = ['(800) 410-1013'];
				this.companyFax = ['(800) 286-7639'];
				this.companyAddress =
					'250 Yonge Street, Suite 3101, P.O. Box 3, Toronto, ON';
				this.setContactDetails(this.titlePlusContact);
				break;
			default:
				break;
		}
	}
}
